<template>
<list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        ref="grid"
        v-model="selected"
        :value-key="['IdCIFEmpresa','DIR', 'PGE']"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @actionclick='openPath'
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' v-if="excelEnabled" :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive 
            mode="primary" 
            :text="$t('configurations.link_dir')"
            icon="link" 
            @click="golinkDirToCif" 
            :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="isCompanyCreation"
            mode="primary" 
            :text="isCompanyCreation && getModulesClient.length ? $t('app.save_and_continue') : $t('app.save')"
            icon="link" 
            @click="goNext" 
            :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <base-button size="xs" mode="tools" custom="w-full" @click="unlink">
            <span class="flex items-center w-full">
              <base-icon name="trash" size="sm" class="mr-1" />
              {{$t('app.remove')}}
            </span>
          </base-button>
        </template>
      </base-table-select-actions-expand>
      <cif-link-dirs-dialog :dialogOpen="golinkDirToCifDialog" :cifEmpresaId="$route.params.id" :cifEmpresaCif="companyCif" @toggleDialog="toggleDialogs" @applyDialog="applyDirHandler" />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista"
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>
<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/CIFEmpresaDIRFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { getConfiguracionRecepcion } from '@/services/configurations/getConfiguracionRecepcion'
import { getCompany } from '@/services/companies/getCompany'
import { i18n } from '@/i18n'

import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import CifLinkDirsDialog from '../../components/CifLinkDirsDialog.vue'
import { altaConfiguracionRecepcion } from '@/services/configurations/altaConfiguracionRecepcion'
import { borrarConfiguracionRecepcion } from '@/services/configurations/borrarConfiguracionRecepcion'
import { getConfiguracionRecepcionExcel } from '@/services/configurations/getConfiguracionRecepcionExcel'
import { setTransitionAllowed } from '@/services/functions/modeAllowedTransitionHelper'

export default {
  name: 'pge-list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    CifLinkDirsDialog
  },
  data: function () {
    return {
      idVista: 44,
      header: {
        title: i18n.t('companies.configuration_rec.dir_header'),
        icon: 'config',
        breadcrumb: {},
        url: 'companies/detail'
      },
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      golinkDirToCifDialog: false,
      spanish: true,
      vuexnamespace: 'companiespge',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      companyCif: '',
      excelEnabled: false
    }
  },
  computed: {
    id: function () {
      return parseInt(this.$route.params.id)
    },
    isCompanyCreation: function () {
      return !!this.$store.getters['app/isInMode'](3)
    },
    getModulesClient: function () {
      return this.$store.getters['app/getModulesClient']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    pgeTypes: function () {
      return this.$store.getters['config/TIPOS_PGE']
    },
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  created: function () {
  },
  mounted: async function () {
    if (this.isCompanyCreation) {
      this.golinkDirToCifDialog = true
    }

    const companyId = this.$route.params.id
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: i18n.t('companies.header') })
    
    const company = await this.downloadData(companyId)
    this.companyCif = company.CIF
    breadcrumbs.push({ path: '', name: company.RazonSocial })
    this.$store.commit('app/setheaderBreadCrumb', company.RazonSocial)

    this.header.breadcrumb = breadcrumbs

    if (!this.isCompanyCreation) {
      this.data = await this.applyFilters()
    } else {
      this.$store.commit('app/setModulesClient', this.getModulesClient.filter(x => ![12].includes(x)))
    }
  },
  methods: {
    openPath: function (event) {
      // this.$router.push({ name: 'configurations/dirs/details', params: { id: event.dataItem.idCIFEmpresa } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.golinkDirToCifDialog = !this.golinkDirToCifDialog
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        IdCIFEmpresa: this.$route.params.id,
        DIR: data.DIR ? data.DIR.value : null,
        PGE: data.PGE ? data.PGE.value : null
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.DIR)
        payload.listaIDs = selectedIDs
      }
      try {
        const response = await getConfiguracionRecepcionExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'empresa-dirs.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        IdCIFEmpresa: this.$route.params.id,
        DIR: data.DIR && data.DIR.value ? data.DIR.value : '',
        PGE: data.PGE && data.PGE.value && data.PGE.value.length ? data.PGE.value : ''
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        return data.map(item => {
          item.PGE = this.pgeTypes.find(x => x.id === item.PGE)?.name ?? item.PGE
          return item
        })
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(`${i18n.t('feedback.error.general')} ${error}`)
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getConfiguracionRecepcion(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    downloadData: async function (id) {
      let company = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          IdCIFEmpresa: id
        }
        company = await getCompany(params)
        if (company.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', company))
        } else {
          company = company.CIFEmpresa
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return company
    },
    unselect: function () {
      this.selected = []
    },
    unlink: async function () {
      const selected = this.selected
      await this.unlinkHandler(selected)
      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (dirs = [{ IdCIFEmpresa: null, PGE: null, DIR: null }]) {
      try {
        this.$store.commit('setIsLoading', true)
        const idEmpresa = this.$route.params.id
        const payload = dirs.map(x => { x.IdCIFEmpresa = idEmpresa; return x })
        const response = await borrarConfiguracionRecepcion(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_deleted_msg'), 'success')
          this.unselect()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    golinkDirToCif: function () {
      this.golinkDirToCifDialog = !this.golinkDirToCifDialog
    },
    applyDirHandler: async function (dirs = [{ IdCIFEmpresa: null, PGE: null, DIR: null }]) {
      this.linkDirToUser = false
      await this.linkHandler(dirs)
      this.applyFilters()
    },
    linkHandler: async function (dirs = [{ IdCIFEmpresa: null, PGE: null, DIR: null }]) {
      try {
        this.$store.commit('setIsLoading', true)
        const idEmpresa = this.$route.params.id
        const payload = dirs.map(x => { x.IdCIFEmpresa = x.IdCIFEmpresa ? x.IdCIFEmpresa : idEmpresa; return x })
        const response = await altaConfiguracionRecepcion(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.golinkDirToCifDialog = !this.golinkDirToCifDialog
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
    goNext () {
      const modules = this.getModulesClient 
      if (modules.length > 0) {
        setTransitionAllowed(3, true)
        if (modules.includes(1)) {
          this.$router.push({ name: 'companies/apsconfig', params: { id: this.id } })
        } else {
          this.goBack()
        }
      } else {
        this.goBack()
      }
    },
    goBack () {
      this.$store.dispatch('app/exitMode', 3)
      this.$router.push({ name: 'companies' })
    }
  }
}
</script>

<style lang="scss" scoped></style>
